<mat-form-field 
 *ngIf="objets !== undefined && parentForm && myControl" 
  class="full-width no-padding"   
  [floatLabel]="auto"
  [formGroup]="parentForm">
      <mat-label *ngIf="libelle">{{libelle}}</mat-label>
      <input type= "text"
        matInput
        [required]="true"
        [formControl]="myControl"
        [placeholder]="placeholder"
        [matAutocomplete]="auto">
    <mat-autocomplete 
      autoActiveFirstOption 
      panelWidth="auto"
      #auto="matAutocomplete"
      (optionSelected)="onObjetChange($event)">
      <mat-option *ngFor="let obj of filteredObjets | async" [value]="obj"> {{obj}}</mat-option>
    </mat-autocomplete>
    <mat-error *ngIf="myControl.hasError('forbiddenNames')">
      Veuillez sélectionner une valeur suggérée
    </mat-error>
    <mat-error *ngIf="myControl.hasError('required')">
      Veuillez sélectionner une valeur
    </mat-error>
</mat-form-field>
